<template>
	<div v-if="list && list.length > 0">
		<client-only>
			<div class="swiper-outside-container">
				<swiper
					ref="swiper"
					class="swiper"
					:options="swiperOption"
				>
					<swiper-slide
						v-for="(item, n) in list.slice(0, max)"
						:ref="`slide${n}`"
						:key="n"
					>
						<z-img
							alt="Portfolio image"
							:storage="item.image || item"
							width="100%"
							download
						/>
					</swiper-slide>
					<div
						slot="pagination"
						class="swiper-pagination py-2"
						:class="{'bullets-white': white, 'center': pagingCenter}"
					/>
				</swiper>
				<v-btn
					v-if="pageControl"
					aria-label="Previous portfolio item"
					color="white"
					min-width="52"
					elevation="10"
					class="controller d-none d-md-flex px-0"
					absolute
					tile
					x-large
					@click="swipePrev"
				>
					<v-icon class="red--text">
						mdi-chevron-left
					</v-icon>
				</v-btn>
				<v-btn
					v-if="pageControl"
					aria-label="Next portfolio item"
					color="red"
					min-width="52"
					elevation="10"
					class="controller d-none d-md-flex px-0"
					absolute
					tile
					x-large
					@click="swipeNext"
				>
					<v-icon class="white--text">
						mdi-chevron-right
					</v-icon>
				</v-btn>
				<v-btn
					v-if="!pagingCenter"
					aria-label="See more our portfolio"
					absolute
					text
					color="white"
					:to="{name: 'portfolio'}"
				>
					ดูทั้งหมด
					<v-icon right>
						mdi-arrow-right
					</v-icon>
				</v-btn>
			</div>
		</client-only>
	</div>
</template>

<script>

import { mapActions } from 'vuex'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
	components: {
		Swiper,
		SwiperSlide
	},

	props: {
		white: {
			type: Boolean,
			default: false
		},
		pagingCenter: {
			type: Boolean,
			default: false
		},
		pageControl: {
			type: Boolean,
			default: false
		},
		count: {
			type: Number,
			default: 4
		},
		display: {
			type: Number,
			default: 1
		},
		items: {
			type: Array,
			default: () => []
		},
		max: {
			type: Number,
			default: 9999
		},
		query: {
			type: Object,
			default: () => ({})
		}
	},

	data:() => ({
		list: [],
		model: null,
		property: null,
		maxHeight: '100%'
	}),

	computed: {
		swiperOption () {
			let items = 1.2
			if (this.display === 3) {
				if (this.$vuetify.breakpoint.sm) {
					items = 2.2
				}
				if (process.client && window.innerWidth > 750) {
					items = 2.2
				}
				if (this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl) {
					items = 3
				}
			} else {
				if (this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl) {
					items = 1
				}
			}
			return {
				pagination: {
					el: '.swiper-pagination',
					type: 'bullets',
					dynamicBullets: true,
					dynamicMainBullets: 3
				},
				centeredSlides: items !== this.display,
				centeredSlidesBounds: true,
				// grabCursor: true,
				slidesPerView: items,
				slidesPerGroup: 1,
				spaceBetween: 15,
			}
		},
	},

	created() {
		if (process.client) {
			this.getPortfolio(this.query).then(obj => {
				this.list = obj.data.portfolios || obj.data
			})
		}
	},

	methods: {
		...mapActions({
			getPortfolio: 'page/getPortfolio'
		}),

		swipePrev () {
			if (this.$refs.swiper.$swiper) {
				this.$refs.swiper.$swiper.slidePrev()
			}
		},
		swipeNext () {
			if (this.$refs.swiper.$swiper) {
				this.$refs.swiper.$swiper.slideNext()
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.swiper-outside-container {
	position: relative;

	.swiper-container {
		padding-bottom: 72px;
	}
	& > :not(.controller).v-btn--absolute {
		bottom: 15px;
    right: 5px;
    left: unset;
		z-index: 2;
	}
	& > .controller.v-btn--absolute {
		top: 50%;
    right: -52px;
    left: unset;

		&:first-of-type {
			margin-top: -98.5px;
		}
		&:last-of-type {
			margin-top: -46.5px;
		}
	}

	.swiper-pagination::v-deep {
		bottom: 20px !important;

		&:not(.center) {
			left: 7%;
		}
		.swiper-pagination-bullet {
			background-color: #ed1c24;

			&.swiper-pagination-bullet-active::before {
				content: ' ';
				position: absolute;
				top: -2px;
				left: -2px;
				width: 12px;
				height: 12px;
				border: solid 1px #ed1c24;
				border-radius: 50%;
			}
		}

		&.bullets-white {
			.swiper-pagination-bullet {
				background-color: #fff !important;

				&.swiper-pagination-bullet-active::before {
					border-color: #fff !important;
				}
			}
		}
	}

	& ::v-deep .swiper-wrapper {
		height: unset !important;
	}
	& .swiper-slide {
		width: unset;
		height: unset !important;
	}
}
</style>
